import reanimatedJS from './js-reanimated';

export default reanimatedJS;
